import React from "react";
import './styles.css'
import { Information, Title } from 'components/Typography';

// Same typography the /courses overview cards use (adminMarketPlaceCourse/components/
// courseOverviewCard.js): <Title> for the count, <Information> for the label. Taking the
// shared styled-components rather than restating their sizes in styles.css keeps the two
// dashboards in step — a change to Typography.js moves both.
const ScheduleStatsCard = ({ title, count, icon, bgColor }) => {
  return (
    <div className="stats-card">
      <div className="stats-left">
        <Title>{count}</Title>
        <Information>{title}</Information>
      </div>

      <div
        className="stats-icon"
        style={{ backgroundColor: bgColor }}
      >
        <img src={icon} alt={title} />
      </div>
    </div>
  );
};

export default ScheduleStatsCard;
